import React from "react"

const Paragraph = ({ text, mb, isBlog }) => {
  const getContent = text => {
    return {
      __html: text,
    }
  }
  return (
    <section className="paragraph-text">
      <div className={isBlog ? " " : "container"}>
        <div dangerouslySetInnerHTML={getContent(text)}></div>
      </div>
    </section>
  )
}

export default Paragraph
